// OutOfStockBadge - Subtle muted-grey badge used on search cards once the
// progressive stock-check has confirmed no linked supplier has stock at a
// nearby branch/depot and none can backorder it. Same shape/size as
// InStockBadge so the two swap in place without layout shift.

export interface OutOfStockBadgeProps {
  className?: string
}

export function OutOfStockBadge({ className = '' }: OutOfStockBadgeProps) {
  return (
    <span
      className={`inline-block whitespace-nowrap text-[11px] bg-gray-100 text-gray-500 px-2 py-0.5 rounded-md font-medium ${className}`}
    >
      UNAVAILABLE
    </span>
  )
}
